import ResetPasswordPage from './ResetPassword';

export default ResetPasswordPage;
